import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Youtube } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_9d18eba3-f81c-4175-a241-09119da09ef9/artifacts/lx9rjtoy_WhatsApp%20Image%202026-03-01%20at%204.03.51%20PM.jpeg";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src={LOGO_URL} alt="Pharma Palace" className="h-10 w-10 rounded-xl" />
              <span className="font-bold text-lg text-white">Pharma <span className="text-cyan-400">Palace</span></span>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed mb-4">Your trusted online pharmacy for genuine medicines, health products and wellness solutions delivered to your doorstep.</p>
            <div className="flex gap-3">
              {[Facebook, Twitter, Instagram, Youtube].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-full bg-slate-800 flex items-center justify-center hover:bg-cyan-600 transition-colors"><Icon className="w-4 h-4" /></a>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm">Quick Links</h4>
            <div className="space-y-2">
              {[["Medicines", "/products?category=Medicines"], ["Personal Care", "/products?category=Personal+Care"], ["Health Devices", "/products?category=Devices"], ["All Brands", "/products"], ["Health Articles", "/products"]].map(([name, url]) => (
                <Link key={name} to={url} className="block text-sm text-slate-400 hover:text-cyan-400 transition-colors">{name}</Link>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm">Customer Support</h4>
            <div className="space-y-2">
              {["FAQ", "Shipping Policy", "Return Policy", "Privacy Policy", "Terms & Conditions"].map(name => (
                <Link key={name} to="/" className="block text-sm text-slate-400 hover:text-cyan-400 transition-colors">{name}</Link>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm">Contact Us</h4>
            <div className="space-y-3">
              <a href="mailto:help.pharmapalace@gmail.com" className="flex items-center gap-2 text-sm text-slate-400 hover:text-cyan-400"><Mail className="w-4 h-4 shrink-0" /> help.pharmapalace@gmail.com</a>
              <a href="tel:+911800123456" className="flex items-center gap-2 text-sm text-slate-400 hover:text-cyan-400"><Phone className="w-4 h-4 shrink-0" /> 1800-123-456 (Toll Free)</a>
              <p className="flex items-start gap-2 text-sm text-slate-400"><MapPin className="w-4 h-4 shrink-0 mt-0.5" /> Pharma Palace HQ, Health Street, Mumbai 400001</p>
            </div>
            <div className="mt-4 flex gap-2">
              <div className="px-3 py-1.5 bg-slate-800 rounded-lg text-xs text-center"><span className="text-slate-500 block text-[10px]">ISO</span><span className="text-white font-semibold">9001</span></div>
              <div className="px-3 py-1.5 bg-slate-800 rounded-lg text-xs text-center"><span className="text-slate-500 block text-[10px]">100%</span><span className="text-white font-semibold">Genuine</span></div>
              <div className="px-3 py-1.5 bg-slate-800 rounded-lg text-xs text-center"><span className="text-slate-500 block text-[10px]">Licensed</span><span className="text-white font-semibold">Pharmacy</span></div>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">&copy; 2026 Pharma Palace. All rights reserved.</p>
          <div className="flex gap-4">
            {["Visa", "Mastercard", "UPI", "Net Banking"].map(m => (
              <span key={m} className="text-[10px] px-2 py-1 bg-slate-800 rounded text-slate-400">{m}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
